import React from 'react'

import { cn } from '@/helpers/cn'

interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {
  variant?: 'body' | 'bodySmall' | 'bodyBold'
}

export const Paragraph = React.forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, variant = 'body', children, ...props }, ref) => {
    const baseStyles = 'overflow-hidden text-ellipsis text-body-text-primary'

    const variantStyles = {
      body: 'font-nunito text-base font-normal leading-6 m-0',
      bodySmall: 'text-body-text-alternative text-sm font-normal leading-5 m-0',
      bodyBold: 'font-nunito text-base font-bold leading-6 m-0',
    }

    return (
      <p ref={ref} className={cn(baseStyles, variantStyles[variant], className)} {...props}>
        {children}
      </p>
    )
  }
)

Paragraph.displayName = 'Paragraph'
